// extracted by mini-css-extract-plugin
export default {"container":"SummarySection_container__TmTig"};